/**
 * 객체 설정 > 그룹 형태의 객체 Store
 *
 * @since 2018-06-12
 * @author kdydesign.kim
 */
import {ObjectSecProfileApiPrefix as objApiPrefix, CmApiPrefix as cmApiPrefix} from 'utils'
import {i18n} from '~/plugins/i18n'
import { objectSetDataParser, appFilterSaveFormatData, parseAddrObjectTypeNumber, parseAddrObjectIpVersionType } from 'objectSettingsUtils'
const appGroupData = () => { // 애플리케이션 그룹 객체 데이터
  return { app_obj_name: '', mmbr_count: 0, mmbr_obj: [], app_obj_desc: '' }
}
const appFilterData = () => { // 애플리케이션 필터 객체 데이터
  return {
    app_filter_obj_uname: '',
    app_cate: [],
    app_tech: [],
    app_char: [],
    app_tag: [],
    app_cntry: [],
    app_risk: [],
    app_filter_obj_desc: ''
  }
}
const serviceGroupData = () => { // 서비스 그룹 객체 데이터
  return { srv_obj_uname: '', srv_obj_desc: '', mmbr_obj: [], cfg_layer: 1 }
}

const addressGroupData = (zone) => { // 주소 객체 - 그룹 객체 데이터
  return {
    addr_obj_uname: '',
    addr_obj_zone_type: zone !== void 0 ? zone : 1,
    addr_obj_desc: '',
    mmbr_obj: [],
    cfg_layer: 1
  }
}
const addressUserGroupData = () => { // 주소 객체 - 사용자 그룹 객체 데이터
  return { usr_grp_dmn: void 0, usr_grp_name: void 0, usr_grp_desc: void 0, mmbr_obj: [] }
}
const addressIpUserGroupData = () => { // 주소 객체 - IP 매핑 사용자 그룹 객체 데이터
  return { grp_name: void 0, desc: void 0, mmbr_obj: [] }
}

const addressDeviceGroupData = () => { // 주소 객체 - 디바이스 그룹 객체 데이터
  return { name: void 0, desc: void 0, mmbr_obj: [], copy_grp_id: null }
}
const deviceGroupSecPolicyData = () => { // 주소 객체 - 디바이스 그룹 객체 - 보안 정책 데이터
  return {
    osList: [],
    customProgramList: [],
    customUserProgramData: { os_type: 1, name: void 0, ver: void 0, path: void 0 },
    os: { os_type: 0, dvc_rule_equal: void 0, os_version: void 0 },
    security: [],
    program: [],
    custom: []
  }
}
const getSameIndex = (oldObj, n, mmbrPickList) => {
  return _.findIndex(oldObj.mmbr_obj, o => {
    const newMmbr = _.pick(n, mmbrPickList)
    const oldMmbr = _.pick(o, mmbrPickList)
    return _.isEqual(newMmbr, oldMmbr)
  })
}
const isShowRefs = (newObj, oldObj) => {
  const refObj = _.get(newObj, ['ref'], void 0) || _.get(oldObj, ['ref'], {})
  let isRefs = false
  Object.keys(refObj).forEach((key) => {
    if (!/ref$/.test(key)) return
    if (refObj[key] === true) isRefs = true
  })
  if (!isRefs) return false
  // Step 1, #31916 - 이슈에서 정의
  const pickList = ['app_cate', 'app_char', 'app_cntry', 'app_risk', 'app_tag', 'app_tech']
  pickList.push(...['custom', 'os', 'program', 'security'])
  const newD = _.pick(newObj, pickList)
  const oldD = _.pick(oldObj, pickList)
  const res = !_.isEqual(newD, oldD) // 서로 값이 다를때에 true
  if (res) return true
  // Step 2 : Exists mmbr_obj, 둘다 없다면 바로 반환, 둘중 하나는 다름, 둘다 있지만 길이가 다름
  if (_.has(newObj, ['mmbr_obj']) === false && _.has(oldObj, ['mmbr_obj']) === false) return res
  if (_.has(newObj, ['mmbr_obj']) !== _.has(oldObj, ['mmbr_obj'])) return true
  if (newObj.mmbr_obj.length !== oldObj.mmbr_obj.length) return true
  // Step 3 : compare mmbr_obj
  const mmbrPickList = ['dvc_obj_id', 'dvc_alias', 'ip_map_svr_id', 'ip_map_usr_id', 'usr_obj_id', 'addr_obj_id', 'srv_obj_id', 'app_obj_id']
  for (let i = 0, l = newObj.mmbr_obj.length; i < l; i++) {
    const n = newObj.mmbr_obj[i]
    const isSameIndex = getSameIndex(oldObj, n, mmbrPickList)
    if (isSameIndex === -1) return true
  }
  return false
}
export const state = () => ({
  groupDataList: [],
  appGroupData: appGroupData(),
  appFilterData: appFilterData(),
  serviceGroupData: serviceGroupData(),
  addressGroupData: addressGroupData(),
  addressUserGroupData: addressUserGroupData(),
  addressDeviceGroupData: addressDeviceGroupData(),
  addressIpUserGroupData: addressIpUserGroupData(),
  deviceGroupSecPolicyData: deviceGroupSecPolicyData(),
  groupServiceList: [],
  groupAppList: [],
  groupAddressList: [],
  addGroupInDataList: [],
  selectedData: void 0,
  selectedSubData: void 0,
  maxGroupObjectCount: 0,
  copyData: void 0
})
export const mutations = {
  // DDoS 보호도메인에 추가할 하나의 그룹객체 안에는 16개 이하의 객체만 포함가능
  setMaxGroupObjectCount (state, data) { state.maxGroupObjectCount = data },
  // zone 설정
  setZone (state, data) { state.addressGroupData.addr_obj_zone_type = data },
  resetGroupCopyData (state) { state.copyData = void 0 },
  // 그룹 객체 목록 조회
  setGroupObjectDataList (state, data) {
    const groupDataList = _.map(data, (obj) => { return objectSetDataParser(obj) })
    state.groupDataList = Object.freeze(groupDataList)
    data = Object.freeze(data)
  },
  // 그룹에 추가될 목록 초기화
  resetParseGroupObjDataList (state) {
    state.groupServiceList = []
    state.groupAppList = []
    state.groupAddressList = []
  },
  // 서비스 그룹 추가될 목록
  setServiceObjDataList (state, data) { state.groupServiceList = Object.freeze(data) },
  // 애플리케이션 그룹 추가될 목록
  setAppObjDataList (state, data) { state.groupAppList = Object.freeze(data) },
  // 주소 객체 그룹 추가될 목록
  parseAddressObjDataList (state, data) {
    const addressObjectDataList = _.map(_.cloneDeep(data), (obj) => { return objectSetDataParser(obj) })
    state.groupAddressList = Object.freeze(addressObjectDataList)
    data = Object.freeze(data)
  },
  // 주소 객체 저장
  saveGroupAddressData (state, {result, objectType}) {
    const groupAddressList = _.cloneDeep(state.groupAddressList)
    if (/^address\.(host\.(4|6)|network\.(4|6)|domain)$/.test(objectType)) groupAddressList.unshift(objectSetDataParser(result))
    else if (/in/.test(objectType) && result.addr_obj_zone_type === 1) groupAddressList.unshift(objectSetDataParser(result))
    else if (/out/.test(objectType) && result.addr_obj_zone_type === 2) groupAddressList.unshift(objectSetDataParser(result))
    else if (/dmz/.test(objectType) && result.addr_obj_zone_type === 3) groupAddressList.unshift(objectSetDataParser(result))
    else if (!/(\.in|\.out|\.dmz)/.test(objectType)) groupAddressList.unshift(objectSetDataParser(result))
    state.groupAddressList = Object.freeze(groupAddressList)
  },
  // 선택된 데이터 설정
  selectGroupData (state, data) { state.selectedData = data },
  // 선택된 추가할 객체 데이터 설정
  selectGroupSubData (state, data) { state.selectedSubData = data },
  // 그룹 객체 조회
  setGroupObjectData (state, {result, groupType, rootState, mode, path}) {
    const store = rootState.cm.objectSecProfile.object.objectSettings
    if (groupType === 'applicationGroup') {
      if (mode !== 'select') state.appGroupData = result
      state.appGroupData.mmbr_obj = Object.freeze(result.mmbr_obj)
      store.applicationObject.appObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType === 'applicationFilter') {
      if (mode !== 'select') state.appFilterData = result
      state.appFilterData.mmbr_obj = Object.freeze(result.mmbr_obj)
      store.applicationObject.appObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType === 'serviceGroup') {
      if (mode !== 'select') state.serviceGroupData = result
      const mmbrObjList = _.cloneDeep(result.mmbr_srv_obj_list)
      result.mmbr_srv_obj_list = null
      delete result.mmbr_srv_obj_list
      state.serviceGroupData.mmbr_obj = Object.freeze(mmbrObjList)
      store.serviceObject.serviceObjectDataList = Object.freeze(mmbrObjList)
    }
    if (groupType.indexOf('address.group') > -1) {
      if (mode !== 'select') state.addressGroupData = result
      const mmbrObjList = _.cloneDeep(result.mmbr_obj_list)
      result.mmbr_obj_list = null
      delete result.mmbr_obj_list
      state.addressGroupData.mmbr_obj = Object.freeze(mmbrObjList)
      store.addressObject.addressObjectDataList = Object.freeze(mmbrObjList)
    }
    if (groupType === 'address.user.group') {
      if (mode !== 'select') state.addressUserGroupData = result
      state.addressUserGroupData.mmbr_obj = Object.freeze(result.mmbr_obj)
      store.addressObject.addressObjectDataList = Object.freeze(_.map(result.mmbr_obj, (o) => {
        return _.assign(o, {
          parseName: o.dmn === '' ? o.login_id : `${o.dmn}\\${o.login_id}`,
          parseType: o.type === 1 ? i18n.t('op.objectSettings_label_localDB') : i18n.t('cmn.outside')
        })
      }))
    }
    if (groupType === 'address.user.ipMappingGroup') {
      if (mode !== 'select') state.addressIpUserGroupData = result
      state.addressIpUserGroupData.mmbr_obj = Object.freeze(result.mmbr_obj)
      store.addressObject.addressObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType === 'address.device.group') {
      if (mode !== 'select') state.addressDeviceGroupData = result
      state.addressDeviceGroupData.mmbr_obj = Object.freeze(result.mmbr_obj)
      if (path === '/anyexp') {
        store.addressObject.addressObjectDataList = Object.freeze([])
        state.addGroupInDataList = Object.freeze(result.mmbr_obj)
      } else {
        store.addressObject.addressObjectDataList = Object.freeze(result.mmbr_obj)
      }
    }
  },
  // 그룹 객체 포함된 객체 조회
  setAddGroupInDataList (state, {groupType, rootState}) {
    const store = rootState.cm.objectSecProfile.object.objectSettings
    let mmbrObj = void 0
    if (['applicationGroup', 'applicationFilter'].includes(groupType)) mmbrObj = _.clone(store.applicationObject.appObjectDataList)
    if (groupType === 'serviceGroup') mmbrObj = _.clone(store.serviceObject.serviceObjectDataList)
    if (groupType.indexOf('address.group') > -1) mmbrObj = _.clone(store.addressObject.addressObjectDataList)
    state.addGroupInDataList = Object.freeze(mmbrObj)
  },
  // 그룹 객체 저장
  saveGroupObjectData (state, data) {
    const groupDataList = _.cloneDeep(state.groupDataList)
    const convertData = _.assignIn(objectSetDataParser(_.cloneDeep(data)), {
      mmbr_count: _.get(data, ['mmbr_obj', 'length'], 0)
    })
    groupDataList.unshift(convertData)
    state.groupDataList = Object.freeze(groupDataList)
    data = Object.freeze(data)
  },
  // 그룹 객체 삭제
  deleteGroupObjectData (state, {objectType}) {
    const groupDataList = _.cloneDeep(state.groupDataList)
    const keyDict = {
      'applicationGroup': 'app_obj_id',
      'applicationFilter': 'app_filter_obj_id',
      'serviceGroup': 'srv_obj_id',
      'address.group.4': 'addr_obj_id',
      'address.group.4.in': 'addr_obj_id',
      'address.group.4.out': 'addr_obj_id',
      'address.group.4.dmz': 'addr_obj_id',
      'address.group.6': 'addr_obj_id',
      'address.group.6.in': 'addr_obj_id',
      'address.group.6.out': 'addr_obj_id',
      'address.group.6.dmz': 'addr_obj_id',
      'address.user.group': 'usr_grp_id',
      'address.user.ipMappingGroup': 'ip_map_grp_id',
      'address.device.group': 'dvc_grp_id'
    }
    const key = keyDict[objectType]
    const itemIndex = _.findIndex(state.groupDataList, o => { return o[key] === state.selectedData[key] })
    groupDataList.splice(itemIndex, 1)
    state.groupDataList = Object.freeze(groupDataList)
  },
  // 그룹 객체 일괄 삭제
  deleteBatchGroupObjectData (state, {items, groupType}) {
    const groupDataList = _.cloneDeep(state.groupDataList)
    let itemIndex = void 0
    _.forEach(items, (o) => {
      if (groupType === 'applicationGroup') itemIndex = _.findIndex(groupDataList, {app_obj_id: o.app_obj_id})
      if (groupType === 'applicationFilter') itemIndex = _.findIndex(groupDataList, {app_filter_obj_id: o.app_filter_obj_id})
      if (groupType === 'serviceGroup') itemIndex = _.findIndex(groupDataList, {srv_obj_id: o.srv_obj_id})
      if (groupType.indexOf('address.group') > -1) itemIndex = _.findIndex(groupDataList, {addr_obj_id: o.addr_obj_id})
      groupDataList.splice(itemIndex, 1)
    })
    state.groupDataList = Object.freeze(groupDataList)
  },
  // 그룹 객체 수정
  updateGroupObjectData (state, {result, groupType, rootState}) {
    const store = rootState.cm.objectSecProfile.object.objectSettings
    const groupDataList = _.cloneDeep(state.groupDataList)
    let key = void 0
    if (['applicationGroup', 'applicationFilter'].includes(groupType)) {
      key = 'app_obj_id'
      store.applicationObject.appObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType === 'applicationFilter') {
      key = 'app_filter_obj_id'
      store.applicationObject.appObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType === 'serviceGroup') {
      key = 'srv_obj_id'
      store.serviceObject.serviceObjectDataList = Object.freeze(result.mmbr_obj)
    }
    if (groupType.indexOf('address.group') > -1) {
      key = 'addr_obj_id'
      store.addressObject.addressObjectDataList = Object.freeze(result.mmbr_obj)
    }
    const index = _.findIndex(state.groupDataList, {[key]: result[key]})
    const convertData = _.assignIn(objectSetDataParser(result), {
      mmbr_count: _.get(result, ['mmbr_obj', 'length'], 0)
    })
    groupDataList.splice(index, 1, convertData)
    state.groupDataList = Object.freeze(groupDataList)
  },
  // 선택한 데이터 초기화
  resetObjectSelectData (state) { state.selectedData = void 0 },
  // 선택한 데이터 초기화
  resetGroupDataList (state) { state.groupDataList = [] },
  // 선택한 객체 데이터 초기화
  resetObjectData (state, {rootState}) {
    const store = rootState.cm.objectSecProfile.object.objectSettings
    store.applicationObject.appObjectDataList = []
    store.serviceObject.serviceObjectDataList = []
    store.addressObject.addressObjectDataList = []
  },
  // 그룹에 포함된 객체에 추가
  addGroupInObject (state, {data, objectDataKey}) {
    const addGroupInDataList = _.clone(state.addGroupInDataList)
    data.forEach((obj) => { addGroupInDataList.push(obj) })
    state.addGroupInDataList = Object.freeze(addGroupInDataList)
    state[objectDataKey].mmbr_obj = Object.freeze(addGroupInDataList)
  },
  // 그룹 데이터 초기화
  resetGroupObjectData (state, {globalZone, objectDataKey}) {
    if (objectDataKey === 'appGroupData') state.appGroupData = appGroupData()
    if (objectDataKey === 'appFilterData') state.appFilterData = appFilterData()
    if (objectDataKey === 'serviceGroupData') state.serviceGroupData = serviceGroupData()
    if (objectDataKey === 'addressGroupData') state.addressGroupData = addressGroupData(globalZone)
    state.addGroupInDataList = []
  },
  // 그룹에 포함된 객체 삭제
  removeGroupInObject (state, {type, selectedData, objectDataKey}) {
    let addGroupInDataList = _.cloneDeep(state.addGroupInDataList)
    if (type === 'single' && selectedData) {
      selectedData.forEach((data) => {
        let itemIndex = void 0
        if (objectDataKey === 'appGroupData') itemIndex = _.findIndex(state.addGroupInDataList, {app_obj_id: data.app_obj_id})
        if (objectDataKey === 'serviceGroupData') itemIndex = _.findIndex(state.addGroupInDataList, {srv_obj_id: data.srv_obj_id})
        if (objectDataKey === 'addressGroupData') itemIndex = _.findIndex(state.addGroupInDataList, {addr_obj_id: data.addr_obj_id})
        addGroupInDataList.splice(itemIndex, 1)
      })
    }
    if (type === 'all') {
      addGroupInDataList = []
      state.addGroupInDataList = []
      state.appGroupData.mmbr_obj = []
      state.serviceGroupData.mmbr_obj = []
      state.addressGroupData.mmbr_obj = []
    }
    state.addGroupInDataList = Object.freeze(addGroupInDataList)
    state[objectDataKey].mmbr_obj = Object.freeze(addGroupInDataList)
  },

  // 디바이스 그룹 - 보안 정책 조회
  getDeviceGroupSecRules (state, result) {
    const os = _.get(result, ['os'], [])
    const useOS = _.find(os, {use: 1})
    let data = { oid: void 0, os_type: 0, dvc_rule_equal: 1, os_version: void 0 }
    if (useOS) {
      data = {
        oid: useOS.oid,
        os_type: useOS.os_type,
        name: useOS.name,
        ver: useOS.ver,
        path: useOS.path,
        type: useOS.type,
        rule_ver: useOS.rule_ver,
        use: useOS.use,
        dvc_rule_equal: useOS.dvc_rule_equal,
        os_version: useOS.ver
      }
    }
    state.deviceGroupSecPolicyData.osList = result.os
    state.deviceGroupSecPolicyData.os = data
    state.deviceGroupSecPolicyData.security = result.security
    state.deviceGroupSecPolicyData.program = result.program
    state.deviceGroupSecPolicyData.custom = result.custom
    state.deviceGroupSecPolicyData.str = JSON.stringify(result)
  },
  // 디바이스 그룹 - 보안 정책 조회 - 프로그램 - 사용자 정의 프로그램 조회
  getCustomProgramList (state, data) { state.deviceGroupSecPolicyData.customProgramList = data },
  // 디바이스 그룹 - 보안 정책 조회 - 프로그램 - 사용자 정의 프로그램 저장
  saveCustomProgram (state, data) {
    const customProgramList = state.deviceGroupSecPolicyData.customProgramList
    customProgramList.push(data)
  },
  // 디바이스 그룹 - 사용자 정의 프로그램 추가 데이터 초기화
  resetCustomUserProgramData (state) { state.deviceGroupSecPolicyData.customUserProgramData = { os_type: 1, name: void 0, ver: void 0, path: void 0 } },
  // 디바이스 그룹 - 보안 정책 - 점검 프로그램 추가
  addCheckProgram (state, data) { _.forEach(data, (o) => { state.deviceGroupSecPolicyData.program.push(_.assign(o, { dvc_rule_equal: 1 })) }) },
  // 디바이스 그룹 - 보안 정책 - 사용자 정의 프로그램 추가
  addCustomUserProgram (state, data) { _.forEach(data, (o) => { state.deviceGroupSecPolicyData.custom.push(_.assign(o, { dvc_rule_equal: 1 })) }) },
  // 디바이스 그룹 - 보안 정책 - 점검 프로그램/사용자 정의 프로그램 삭제
  deleteProgram (state, {data, type}) {
    let programList = []
    if (type === 'checkProgram') programList = state.deviceGroupSecPolicyData.program
    else if (type === 'customProgram') programList = state.deviceGroupSecPolicyData.custom
    else if (type === 'customProgramList') {
      const customProgramList = state.deviceGroupSecPolicyData.customProgramList
      const customItemIndex = _.findIndex(customProgramList, o => { return o.oid === data.oid })
      if (customItemIndex >= 0) customProgramList.splice(customItemIndex, 1)
      programList = state.deviceGroupSecPolicyData.custom
    }
    const itemIndex = _.findIndex(programList, o => { return o.oid === data.oid })
    if (itemIndex >= 0) programList.splice(itemIndex, 1)
  },
  // 디바이스 그룹 - 보안 정책 - 점검프로그램/사용자 정의 프로그램 조건 변경
  changeProgramCondition (state, {value, item, type}) {
    if (type === 'checkProgram') {
      state.deviceGroupSecPolicyData.program = _.map(state.deviceGroupSecPolicyData.program, (o) => {
        if (o.oid === item.oid) return _.assign(o, { dvc_rule_equal: value })
        else return o
      })
    }

    if (type === 'customProgram') {
      state.deviceGroupSecPolicyData.custom = _.map(state.deviceGroupSecPolicyData.custom, (o) => {
        if (o.oid === item.oid) return _.assign(o, { dvc_rule_equal: value })
        else return o
      })
    }
  },
  // 그룹에 속한 객체 초기화
  resetGroupInDataList (state) { state.addGroupInDataList = [] },
  // 그룹 객체 복사
  copyGroupData (state, {objectType}) {
    const selectedData = _.cloneDeep(state.selectedData)
    const keys = Object.keys(selectedData)
    let data = null
    if (objectType === 'applicationGroup') data = appGroupData()
    else if (objectType === 'applicationFilter') data = appFilterData()
    else if (objectType === 'serviceGroup') data = serviceGroupData()
    else if (objectType.indexOf('address.group') > -1) data = addressGroupData()
    _.each(keys, (key) => {
      if (key === 'dvc_grp_id') data['copy_grp_id'] = selectedData[key]
      else if (_.has(data, key)) data[key] = selectedData[key]
    })
    state.copyData = data
  },
  pasteGroupData (state, {objectType}) {
    const data = _.cloneDeep(state.copyData)
    if (objectType === 'applicationGroup') {
      state.appGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    } else if (objectType === 'applicationFilter') {
      state.appFilterData = data
    } else if (objectType === 'serviceGroup') {
      state.serviceGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    } else if (objectType.indexOf('address.group') > -1) {
      state.addressGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    } else if (objectType === 'address.user.group') {
      state.addressUserGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    } else if (objectType === 'address.device.group') {
      state.addressDeviceGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    } else if (objectType === 'address.user.ipMappingGroup') {
      state.addressIpUserGroupData = data
      state.addGroupInDataList = Object.freeze(_.get(data, ['mmbr_obj'], []))
    }
  },
  resetAddressIpUserGroupData (state) { state.addressIpUserGroupData = addressIpUserGroupData() },
  setDeviceGroupSecPolicyDataOsOid (state, oid) { state.deviceGroupSecPolicyData.os.oid = oid },
  setDeviceGroupSecPolicyDataOsVersion (state, version) { state.deviceGroupSecPolicyData.os.os_version = version },
  setDeviceGroupSecPolicyDataSecurityUse (state, {oid, use = 0}) {
    const securityIndex = _.findIndex(state.deviceGroupSecPolicyData.security, (o) => { return o.oid === oid })
    if (securityIndex === -1) return
    state.deviceGroupSecPolicyData.security[securityIndex].use = use
    state.deviceGroupSecPolicyData.security[securityIndex].dvc_rule_equal = use
  },
  // 그룹에서 선택된 객체 초기화
  resetSelectedGroupData (state) { state.selectedData = void 0 }
}

export const actions = {
  // 그룹 데이터 초기화
  resetGroupObjectData ({commit, rootState}, {objectDataKey}) {
    const globalZone = rootState.cm.objectSecProfile.object.objectSettings.common.globalZone
    commit('resetGroupObjectData', {globalZone, objectDataKey})
  },
  // DDoS 보호도메인에 추가할 하나의 그룹객체 안에는 16개 이하의 객체만 포함가능
  setMaxGroupObjectCount ({commit, state}, data) {
    commit('setMaxGroupObjectCount', data)
  },
  // 선택한 객체 데이터 초기화
  resetObjectData ({commit, rootState}) {
    commit('resetObjectData', {rootState})
  },
  // 그룹 객체 목록 조회
  async getGroupObjectDataList ({commit, state, dispatch}, {target = void 0, apiUrl, loadingShow = true, loadingHide = true} = {}) {
    let uri = ''
    if (apiUrl.indexOf('app-group') > -1 || apiUrl.indexOf('app-filter') > -1) uri = `${objApiPrefix}/${apiUrl}`
    else uri = `${cmApiPrefix}/${apiUrl}`
    let {code, result} = await await this.$axios.$get(uri, {loadingShow, loadingHide})
    if (code === 'ok') {
      if (target !== 'group') {
        commit('setGroupObjectDataList', result)
      } else {
        if (apiUrl.indexOf('app-group') > -1) commit('setAppObjDataList', result)
        else if (apiUrl.indexOf('objects/srv') > -1) commit('setServiceObjDataList', result)
      }
    }
  },
  // 그룹 객체 저장 (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async saveGroupObjectData ({commit, state, rootState, rootGetters, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let data = void 0
    let url = void 0
    if (groupType === 'applicationGroup') {
      url = `${objApiPrefix}/app-group/objects`
      data = {
        app_obj_grp_name: _.trim(state.appGroupData.app_obj_name),
        mmbr_app_obj_id_list: _.map(state.addGroupInDataList, 'app_obj_id'),
        app_obj_grp_kr_desc: state.appGroupData.app_obj_desc,
        force: forceYn
      }
    }
    if (groupType === 'applicationFilter') {
      const appSearchFilter = rootState.cm.objectSecProfile.object.objectSettings.applicationObject.appSearchFilter
      const saveForm = appFilterSaveFormatData(appSearchFilter)
      url = `${objApiPrefix}/app-filter/objects`
      data = {
        app_filter_obj_uname: _.trim(state.appFilterData.app_filter_obj_uname),
        app_cate_id_list: saveForm.appSearchCategory,
        app_tech_id_list: saveForm.appSearchTech,
        app_char_id_list: saveForm.appSearchChar,
        app_tag_id_list: saveForm.appSearchTag,
        app_cntry_id_list: saveForm.appSearchCountry,
        app_risk_id_list: saveForm.appSearchRisk,
        app_filter_obj_desc: state.appFilterData.app_filter_obj_desc
      }
    }
    if (groupType === 'serviceGroup') {
      url = `${cmApiPrefix}/objects/srv/grp`
      data = {
        srv_obj_uname: _.trim(state.serviceGroupData.srv_obj_uname),
        mmbr_srv_obj_id_list: _.map(state.serviceGroupData.mmbr_obj, 'srv_obj_id'),
        srv_obj_desc: _.isUndefined(state.serviceGroupData.srv_obj_desc) ? '' : state.serviceGroupData.srv_obj_desc,
        force_yn: forceYn
      }
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      url = `${cmApiPrefix}/objects/grp`
      data = {
        addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
        addr_obj_uname: state.addressGroupData.addr_obj_uname,
        addr_obj_zone_type: state.addressGroupData.addr_obj_zone_type,
        mmbr_addr_obj_id_list: _.map(state.addressGroupData.mmbr_obj, 'addr_obj_id'),
        addr_obj_desc: _.isUndefined(state.addressGroupData.addr_obj_desc) ? '' : state.addressGroupData.addr_obj_desc,
        force_yn: forceYn
      }
    }
    const res = await this.$axios.$post(url, data, {loadingShow, loadingHide, successAlert})
    if (res.code === 'ok') {
      // 추후 타 그룹 객체, 추가/계속/편집 시 전체 reload 되지 않는 방식으로 개선 필요.
      if (groupType === 'applicationGroup' || groupType === 'applicationFilter') {
        const resultData = res.result
        commit('saveGroupObjectData', resultData)
      }
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },
  // 그룹 객체 조회
  async getGroupObjectData ({commit, state, rootState}, {mode, loadingShow = true, loadingHide = true, path = ''} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0
    let id = void 0
    if (groupType === 'applicationGroup') {
      if (_.isArray(state.selectedData)) id = _.last(state.selectedData).app_obj_id
      else id = state.selectedData.app_obj_id
      url = `${objApiPrefix}/app-group/objects/${id}`
    }
    if (groupType === 'applicationFilter') {
      if (_.isArray(state.selectedData)) id = _.last(state.selectedData).app_filter_obj_id
      else id = state.selectedData.app_filter_obj_id
      url = `${objApiPrefix}/app-filter/objects/${id}`
    }
    if (groupType === 'serviceGroup') {
      if (_.isArray(state.selectedData)) id = _.last(state.selectedData).srv_obj_id
      else id = state.selectedData.srv_obj_id
      const
        srvObjId = id, // 서비스 객체 아이디, 0인 경우 전체 조회
        srvObjType = 2 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
      url = `${cmApiPrefix}/objects/srv/${srvObjId}/${srvObjType}`
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      const addrObjType = 4, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
        addrObjIpVerType = parseAddrObjectIpVersionType(version),
        zone = 0, // TAMS, 전체 조회
        pageCnt = 0, // 페이지 당 건수
        pagePos = 0 // 조회 페이지, 시작페이지 0부터
      if (_.isArray(state.selectedData)) id = _.last(state.selectedData).addr_obj_id
      else id = state.selectedData.addr_obj_id
      url = `${cmApiPrefix}/objects/${id}/${addrObjType}/${addrObjIpVerType}/${zone}/${pageCnt}/${pagePos}`
    }
    url += path
    const res = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
    if (res.code === 'ok') {
      const result = _.get(res.result, ['length'], 0) > 0 ? res.result[0] : res.result
      commit('setGroupObjectData', {result, groupType, rootState, mode, path})
      commit('selectGroupData', _.assign(state.selectedData, result))
    }
    return res
  },
  // 그룹 객체 조회
  async getLegacyGroupObjectData ({commit, state, rootState}, {mode, selectedData, loadingShow = true, loadingHide = true, path = ''} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0
    let id = void 0
    if (groupType === 'applicationGroup') {
      if (_.isArray(selectedData)) id = _.last(selectedData).app_obj_id
      else id = selectedData.app_obj_id
      url = `${objApiPrefix}/app-group/objects/${id}`
    }
    if (groupType === 'applicationFilter') {
      if (_.isArray(selectedData)) id = _.last(selectedData).app_filter_obj_id
      else id = selectedData.app_filter_obj_id
      url = `${objApiPrefix}/app-filter/objects/${id}`
    }
    if (groupType === 'serviceGroup') {
      if (_.isArray(selectedData)) id = _.last(selectedData).srv_obj_id
      else id = selectedData.srv_obj_id
      const
        srvObjId = id, // 서비스 객체 아이디, 0인 경우 전체 조회
        srvObjType = 2 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
      url = `${cmApiPrefix}/objects/srv/${srvObjId}/${srvObjType}`
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      const addrObjType = 4, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
        addrObjIpVerType = parseAddrObjectIpVersionType(version),
        zone = 0, // TAMS, 전체 조회
        pageCnt = 0, // 페이지 당 건수
        pagePos = 0 // 조회 페이지, 시작페이지 0부터
      if (_.isArray(selectedData)) id = _.last(selectedData).addr_obj_id
      else id = selectedData.addr_obj_id
      url = `${cmApiPrefix}/objects/${id}/${addrObjType}/${addrObjIpVerType}/${zone}/${pageCnt}/${pagePos}`
    }
    url += path
    const res = await this.$axios.$get(`${url}`, {loadingShow, loadingHide})
    if (res.code === 'ok') {
      const result = _.get(res.result, ['length'], 0) > 0 ? res.result[0] : res.result
      commit('setGroupObjectData', {result, groupType, rootState, mode, path})
      commit('selectGroupData', _.assign(selectedData, result))
    }
    return res
  },
  // 그룹 객체 포함된 객체 조회
  getAddGroupInDataList ({commit, state, rootState}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    commit('setAddGroupInDataList', {groupType, rootState})
  },
  // 그룹 객체에 포함된 자식 객체 조회(tree)
  async getChildGroupObjectData ({commit, state, rootState}, {loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0
    let id = void 0
    if (groupType === 'applicationGroup') {
      id = state.selectedSubData.app_obj_id
      url = `${objApiPrefix}/app-group/objects/${id}`
    }
    if (groupType === 'serviceGroup') {
      id = state.selectedSubData.srv_obj_id
      const srvObjType = 2 // 서비스 객체 유형, 1 서비스 객체, 2 서비스 그룹 객체, 0인 경우 전체 조회
      url = `${cmApiPrefix}/objects/srv/${id}/${srvObjType}`
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      id = state.selectedSubData.addr_obj_id
      const
        addrObjType = 4, // 주소 객체 유형, 1 호스트 객체, 2 네트워크 객체 (넷마스크), 3 네트워크 객체 (범위), 4 그룹 객체, 5 도메인 객체, 6 URI 객체 [1,2,3,4,5,6]
        zone = state.addressGroupData.addr_obj_zone_type,
        addrObjIpVerType = parseAddrObjectIpVersionType(version), // 주소 객체 아이피 버전 유형 1 IPv4, 2 IPv6, 3 공통
        pageCnt = 0, // 페이지 당 건수
        pagePos = 0 // 조회 페이지, 시작페이지 0부터
      url = `${cmApiPrefix}/objects/${id}/${addrObjType}/${addrObjIpVerType}/${zone}/${pageCnt}/${pagePos}`
    }
    const {code, result} = await this.$axios.$get(url, {loadingShow, loadingHide})
    if (code === 'ok') {
      if (groupType === 'serviceGroup') {
        return result[0].mmbr_srv_obj_list
      } else if (groupType.indexOf('address.group') > -1) {
        return result[0].mmbr_obj_list
      } else {
        return result.mmbr_obj
      }
    }
  },
  // 그룹 객체 수정 (forceYn 0: 중복객체 에러 리턴, 1: 중복객체 중복추가)
  async updateGroupObjectData ({commit, state, rootState, rootGetters, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0, id = void 0, data = void 0
    if (groupType === 'applicationGroup') {
      id = state.selectedData.app_obj_id
      url = `${objApiPrefix}/app-group/objects/${id}`
      data = {
        app_obj_id: id,
        app_obj_grp_name: state.appGroupData.app_obj_name,
        mmbr_app_obj_id_list: _.map(state.appGroupData.mmbr_obj, 'app_obj_id'),
        app_obj_grp_kr_desc: state.appGroupData.app_obj_desc,
        force: forceYn
      }
    }
    if (groupType === 'applicationFilter') {
      const appSearchFilter = rootState.cm.objectSecProfile.object.objectSettings.applicationObject.appSearchFilter
      const saveForm = appFilterSaveFormatData(appSearchFilter)
      id = state.selectedData.app_filter_obj_id
      url = `${objApiPrefix}/app-filter/objects/${id}`
      data = {
        app_filter_obj_uname: _.trim(state.appFilterData.app_filter_obj_uname),
        app_cate_id_list: saveForm.appSearchCategory,
        app_tech_id_list: saveForm.appSearchTech,
        app_char_id_list: saveForm.appSearchChar,
        app_tag_id_list: saveForm.appSearchTag,
        app_cntry_id_list: saveForm.appSearchCountry,
        app_risk_id_list: saveForm.appSearchRisk,
        app_filter_obj_desc: state.appFilterData.app_filter_obj_desc
      }
    }
    if (groupType === 'serviceGroup') {
      url = `${cmApiPrefix}/objects/srv/grp`
      data = {
        mmbr_srv_obj_id_list: _.map(state.serviceGroupData.mmbr_obj, 'srv_obj_id'),
        srv_obj_desc: _.isUndefined(state.serviceGroupData.srv_obj_desc) ? '' : state.serviceGroupData.srv_obj_desc,
        srv_obj_id: state.serviceGroupData.srv_obj_id,
        srv_obj_uname: state.serviceGroupData.srv_obj_uname,
        force_yn: forceYn
      }
    }
    if (groupType.indexOf('address.group') > -1) {
      url = `${cmApiPrefix}/objects/grp`
      data = {
        addr_obj_uname: state.addressGroupData.addr_obj_uname,
        addr_obj_zone_type: state.addressGroupData.addr_obj_zone_type,
        mmbr_addr_obj_id_list: _.map(state.addressGroupData.mmbr_obj, 'addr_obj_id'),
        addr_obj_desc: _.isUndefined(state.addressGroupData.addr_obj_desc) ? '' : state.addressGroupData.addr_obj_desc,
        addr_obj_id: state.addressGroupData.addr_obj_id,
        addr_obj_ip_ver_type: state.addressGroupData.addr_obj_ip_ver_type,
        force_yn: forceYn
      }
    }
    const res = await this.$axios.$put(`${url}`, data, {loadingShow, loadingHide, successAlert})

    if (res.code === 'ok') {
      if (['applicationGroup', 'applicationFilter'].includes(groupType)) {
        commit('updateGroupObjectData', {result: res.result, groupType, rootState})
      }
      dispatch('common/common/setIsChanged', true, {root: true})
    }
    return res
  },
  // 그룹 객체 삭제
  async deleteGroupObjectData ({commit, state, rootState, dispatch}, {loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0
    let id = void 0
    if (groupType === 'applicationGroup') {
      id = state.selectedData.app_obj_id
      url = `app-group/objects/${id}`
    }
    if (groupType === 'applicationFilter') {
      id = state.selectedData.app_filter_obj_id
      url = `app-filter/objects/${id}`
    }
    if (groupType === 'serviceGroup') {
      id = state.selectedData.srv_obj_id
      url = `service-group/objects/${id}`
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      id = state.selectedData.addr_obj_id
      url = `group/${version}/objects/${id}`
    }
    let code = void 0, cause = void 0
    try {
      const response = await this.$axios.$delete(`${objApiPrefix}/${url}`, {isReturnError: true, loadingShow, loadingHide})
      code = _.get(response, ['code'])
    } catch (e) {
      code = _.get(e, ['data', 'code'])
      cause = _.get(e, ['data', 'message'])
    }
    if (code === 'ok') {
      const objectType = rootState.cm.objectSecProfile.object.objectSettings.common.objectType
      commit('deleteGroupObjectData', {objectType})
      commit('resetObjectSelectData')
      commit('resetObjectData', {rootState})
      dispatch('common/common/setIsChanged', true, {root: true})
    } else if (Number(code) === 15010) { // 삭제 가능
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [],
        forceDelete: [_.assign(selectedData, {cause: cause})]
      }
    } else {
      const selectedData = _.cloneDeep(state.selectedData)
      return {
        notDelete: [_.assign(selectedData, {cause: cause})],
        forceDelete: []
      }
    }
  },
  // 그룹 객체 일괄 삭제 (2019-12-27, [applicationGroup, applicationFilter])
  async deleteBatchGroupObjectData ({commit, state, rootState, dispatch}, {forceYn = 0, loadingShow = true, loadingHide = true, successAlert = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let url = void 0, id = void 0, list = void 0
    if (groupType === 'applicationGroup') {
      id = 'app_obj_id'
      url = `app-group/objects/multi`
      list = `app_obj_id_list`
    }
    if (groupType === 'applicationFilter') {
      id = 'app_filter_obj_id'
      url = `app-filter/objects/multi`
      list = `app_filter_obj_id_list`
    }
    let objIdList = [],
      multiSelectedData = []
    const selectedData = _.cloneDeep(state.selectedData)
    if (_.get(selectedData, ['length'], 0) > 0) {
      objIdList = _.map(selectedData, id)
      multiSelectedData = selectedData
    } else {
      objIdList = [selectedData[id]]
      multiSelectedData = [selectedData]
    }
    const params = { [list]: objIdList, force_yn: forceYn }
    const res = await this.$axios.$put(`${objApiPrefix}/${url}`, params, {loadingShow, loadingHide, successAlert})
    if (res.code === 'ok') {
      res.result.can_not_delete = _.get(res.result, ['can_not_delete'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      res.result.force_delete_pass = _.get(res.result, ['force_delete_pass'], []).map(o => _.assign(o, _.find(multiSelectedData, [id, o[id]])))
      dispatch('common/common/setIsChanged', true, {root: true})
      commit('resetObjectSelectData')
    }
    return res
  },
  // 직접 입력으로 주소 객체 추가
  async saveHostObjData ({commit, state, rootState, dispatch}, {ip, version, zone, loadingShow = true, loadingHide = true, currentTabs = 'host', ruleType, force = 0} = {}) {
    const globalZone = rootState.cm.objectSecProfile.object.objectSettings.common.globalZone
    let nameType = void 0, data = void 0, objectType = void 0, autoCreateName = void 0, objName = void 0
    if (ruleType === 'object') {
      autoCreateName = i18n.t('op.objectSettings_header_objectSettings')
    } else if (['fw', 'fw-context'].some(type => type === ruleType)) {
      if (Number(version) === 4) autoCreateName = i18n.t('cmn.firewallRule')
      if (Number(version) === 6) autoCreateName = i18n.t('cmn.ipv6FirewallRule')
    } else if (ruleType === 'nat') {
      autoCreateName = i18n.t('cmn.natRule')
    } else if (ruleType === 'portal') {
      if (Number(version) === 4) autoCreateName = i18n.t('cmn.portal')
      if (Number(version) === 6) autoCreateName = i18n.t('cmn.ipv6Portal')
    } else if (ruleType === 'appTagging') {
      if (Number(version) === 4) autoCreateName = i18n.t('cmn.appTagging')
      if (Number(version) === 6) autoCreateName = i18n.t('cmn.ipv6AppTagging')
    }
    const netMask = Number(version) === 4 ? 32 : 128 // network object
    if ([ip.indexOf('/') > -1, Number(_.split(ip, '/')[1]) !== netMask].every(item => item)) {
      const ipAddr = _.split(ip, '/')[0]
      const netMask = _.split(ip, '/')[1]
      if (globalZone === 1) nameType = 'IN'
      else if (globalZone === 2) nameType = 'EN'
      else nameType = 'DN'
      objectType = 'network'
      objName = `${ipAddr}_${netMask}_${nameType}`
    } else {
      if (ip.indexOf('/') > -1) ip = _.split(ip, '/')[0]
      if (globalZone === 1) nameType = 'IH'
      else if (globalZone === 2) nameType = 'EH'
      else nameType = 'DH'
      objectType = 'host'
      objName = `${ip}_${nameType}`
    }
    data = {
      addr_obj_uname: objName,
      addr_obj_type: parseAddrObjectTypeNumber(objectType),
      addr_obj_zone_type: zone !== void 0 ? zone : globalZone,
      addr_obj_desc: i18n.t('cmn.autoCreateRule', {rule: autoCreateName}),
      addr_obj_ip_exp: ip,
      addr_obj_ip_ver_type: parseAddrObjectIpVersionType(version),
      force_yn: force
    }
    const res = await this.$axios.$post(`${cmApiPrefix}/objects`, data, { loadingHide, loadingShow })
    if (res.code === 'ok') dispatch('common/common/setIsChanged', true, {root: true})
    return res
  },
  // 디바이스 그룹 - 보안 정책 조회
  async getDeviceGroupSecRules ({commit, state}, {groupId, loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/device-group/objects/${groupId}/policy`, {loadingShow, loadingHide})
    if (code === 'ok') commit('getDeviceGroupSecRules', result)
  },
  // 디바이스 그룹 - 보안 정책 조회 - 프로그램 - 점검 프로그램 조회
  async getCheckProgramList ({loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/device/check/programs`, {loadingShow, loadingHide})
    if (code === 'ok') return result
  },
  // 디바이스 그룹 - 보안 정책 조회 - 프로그램 - 사용자 정의 프로그램 조회
  async getCustomProgramList ({commit}, {loadingShow = true, loadingHide = true} = {}) {
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/device/custom/programs`, {loadingShow, loadingHide})
    if (code === 'ok') commit('getCustomProgramList', result)
  },
  // 디바이스 그룹 - 보안 정책 조회 - 프로그램 - 사용자 정의 프로그램 저장
  async saveCustomProgram ({state, commit, dispatch}, {loadingShow = true, loadingHide = true} = {}) {
    const customUserProgramData = state.deviceGroupSecPolicyData.customUserProgramData
    const {code, result} = await this.$axios.$post(`${objApiPrefix}/device/custom/programs`, customUserProgramData, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('saveCustomProgram', result)
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 디바이스 그룹 - 보안 정책 수정
  async updateDeviceGroupSecRules ({state, commit, dispatch}, {groupId}, {loadingShow = true, loadingHide = true} = {}) {
    const deviceGroupSecPolicyData = state.deviceGroupSecPolicyData
    const sendData = {
      os: deviceGroupSecPolicyData.os,
      security: deviceGroupSecPolicyData.security,
      program: deviceGroupSecPolicyData.program,
      custom: deviceGroupSecPolicyData.custom
    }
    const {code, result} = await this.$axios.$put(`${objApiPrefix}/device-group/objects/${groupId}/policy`, sendData, {loadingShow, loadingHide})
    if (code === 'ok') {
      let isShowRefsD = false
      if (state.groupDataList && state.groupDataList.length > 0) {
        const deviceGroupData = _.find(state.groupDataList, {'dvc_grp_id': groupId})
        const devInfo = {dvc_grp_id: groupId, ref: deviceGroupData.ref}
        const oldDev = _.assign(JSON.parse(state.deviceGroupSecPolicyData.str), devInfo)
        const newDev = _.assign(result, devInfo)
        isShowRefsD = isShowRefs(newDev, oldDev)
      }
      commit('getDeviceGroupSecRules', result)
      dispatch('common/common/setIsChanged', true, {root: true})
      return {isShowRefs: isShowRefsD}
    }
  },
  // 디바이스 그룹 - 보안 정책 - 사용자 정의 프로그램 삭제
  async deleteCustomUserProgram ({state, commit, dispatch}, {oid}) {
    const {code} = await this.$axios.$delete(`${objApiPrefix}/device/custom/programs/${oid}`)
    if (code === 'ok') {
      commit('deleteProgram', {data: {oid: oid}, type: 'customProgramList'})
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 그룹 객체 참조 여부 상세 조회 (미사용, TAMS 전용 통합 API를 통해 참조 여부 조회)
  async getGroupDetailRefData ({commit, state, rootState, dispatch}, {objectData, loadingShow = true, loadingHide = true} = {}) {
    const groupType = rootState.cm.objectSecProfile.object.objectSettings.common.groupType
    let objId = void 0
    let url = void 0
    if (groupType === 'applicationGroup') {
      objId = objectData.app_obj_id
      url = `app-group/objects`
    }
    if (groupType === 'applicationFilter') {
      objId = objectData.app_filter_obj_id
      url = 'app-filter/objects'
    }
    if (groupType === 'serviceGroup') {
      objId = objectData.srv_obj_id
      url = `service-group/objects`
    }
    if (groupType.indexOf('address.group') > -1) {
      const version = groupType.split('.')[2]
      objId = objectData.addr_obj_id
      url = `group/${version}/objects`
    }
    const {code, result} = await this.$axios.$get(`${objApiPrefix}/${url}/${objId}/ref`, {loadingShow, loadingHide})
    if (code === 'ok') {
      commit('cm/objectSecProfile/object/objectSettings/common/setUsedDetailData', result, {root: true})
    }
  }
}
export const getters = {
}
export const strict = false
